import { Dialog, Theme, useMediaQuery } from "@mui/material";

export const DayDialogContainer = ({
  selectedDay,
  handleCloseDayDialog,
  theme,
  children,
}: {
  selectedDay: string;
  handleCloseDayDialog: () => void;
  theme: Theme;
  children: React.ReactNode;
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Dialog
      open={!!selectedDay}
      onClose={handleCloseDayDialog}
      scroll="paper"
      maxWidth={false}
      fullScreen={isMobile}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 1,
            width: isMobile ? "100vw" : "95vw",
            height: isMobile
              ? "calc(100dvh - 112px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))"
              : "auto",
            maxWidth: isMobile ? "100vw" : "1600px",
            maxHeight: isMobile
              ? "calc(100dvh - 112px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))"
              : "90vh",
            m: isMobile ? "0 0 112px 0" : "auto",
            background: `radial-gradient(circle at top left, ${theme.palette.grey[300]}, white)`,
            border: `2px solid #aaa`,
          },
        },
      }}
      sx={{
        display: "flex",
        alignItems: isMobile ? "stretch" : "center",
        justifyContent: isMobile ? "stretch" : "center",
      }}
    >
      {children}
    </Dialog>
  );
};
